import {
  IB_INITIALIZE,
  IB_FETCH_PLAN_SUCCESS,
  IB_FETCH_FORMS_SUCCESS,
  IB_FETCH_AGENTS_SUCCESS,
  IB_FETCH_ENDPOINTS_SUCCESS,
  IB_FETCH_IASERVICES_SUCCESS,
  IB_FETCH_INTEGRATIONS_SUCCESS,
  IB_ENDPOINT_LIST_CHANGED,
  IB_RESET,
} from '../../actions/integrationBuilder';

import {
  ENDPOINT_DELETE_SUCCESS,
  ENDPOINT_SAVE_SUCCESS,
} from '../../actions/endpointsModal';

export const INITIAL_STATE = {
  plan: null,
  forms: null,
  applicationId: null,
  xagents: [],
  endpoints: [],
  iaServices: [],
  integrations: [],
};

export function sortAgents(a, b) {
  let result = 0;
  if (a.status > b.status) {
    result = 1;
  } else if (a.status < b.status) {
    result = -1;
  }
  if (result !== 0) {
    return result;
  }
  if (a.name > b.name) {
    result = 1;
  } else if (a.name < b.name) {
    result = -1;
  }
  return result;
}

export default function planReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case IB_INITIALIZE: {
      return {
        ...state,
        applicationId: action.applicationId,
      };
    }
    case IB_FETCH_PLAN_SUCCESS: {
      return {
        ...state,
        plan: action.payload,
      };
    }
    case IB_FETCH_FORMS_SUCCESS: {
      return {
        ...state,
        forms: action.payload.data,
      };
    }
    case IB_FETCH_AGENTS_SUCCESS: {
      if (typeof action.payload.data !== 'undefined') {
        const sortedData = action.payload.data.sort(sortAgents);
        return {
          ...state,
          xagents: sortedData,
        };
      }
      return {
        ...state,
        xagents: [],
      };
    }
    case IB_FETCH_ENDPOINTS_SUCCESS: {
      if (typeof action.payload.data !== 'undefined') {
        return {
          ...state,
          endpoints: action.payload.data,
        };
      }
      return {
        ...state,
        endpoints: [],
      };
    }
    case IB_FETCH_IASERVICES_SUCCESS: {
      if (typeof action.payload.data !== 'undefined') {
        return {
          ...state,
          iaServices: action.payload.data,
        };
      }
      return {
        ...state,
        iaServices: [],
      };
    }
    case IB_FETCH_INTEGRATIONS_SUCCESS: {
      return {
        ...state,
        integrations: action.payload.data,
      };
    }
    case IB_ENDPOINT_LIST_CHANGED: {
      const json = JSON.parse(action.payload);
      const { name, id, url } = json;
      const index = state.endpoints.findIndex(r => r.id === id);
      const endpoints = [...state.endpoints];

      if (index === -1) {
        // New endpoint, so just add:
        endpoints.push(json);
      } else {
        const endpoint = state.endpoints[index];
        endpoints[index] = { ...endpoint, name, id, url };
      }
      return {
        ...state,
        endpoints,
      };
    }
    case IB_RESET: {
      return INITIAL_STATE;
    }
    case ENDPOINT_SAVE_SUCCESS: {
      return {
        ...state,
        endpoints: [
          ...state.endpoints,
          {
            name: action.payload.name || action.payload.defaultName,
            id: action.payload.id,
            url: action.payload.url,
          },
        ],
      };
    }
    case ENDPOINT_DELETE_SUCCESS: {
      return {
        ...state,
        endpoints: state.endpoints.filter(e => e.id !== action.payload.id),
      };
    }
    default:
      return state;
  }
}
